<div #calendarContainer class="scheduler-calendar-container w-100" style="padding: 15px">
  <loader [loading]="collection.loading$"></loader>

  <div class="month-wrapper" *rxFor="let month of calendar; strategy: strategy$; let select = select; let m = index">
    <div class="calendar-months overflow-hidden">
      <loader [loading]="collection.loading$" [small]="true"></loader>

      <div
        *rxFor="let week of select(['days']); strategy: strategy$; let selectWeek = selectWeek; let i = index"
        class="flex-days">
        <div class="week-number">
          <ng-container *ngIf="week[0]?.date">
            <span>
              {{ week[0]?.date | formatDate: 'W' }}
            </span>
          </ng-container>
        </div>

        <div
          *rxFor="let day of week; strategy: strategy$; let i = index"
          [ngClass]="{ weekend: day.isWeekend }"
          [class.holiday]="isHoliday(day.date)"
          [class.active]="(hoveredDay | async) === day?.date"
          [class.clicked]="(clickedDay | async) === day?.date"
          class="day {{ day?.date }}"
          (mouseout)="disableHover()"
          (mouseover)="setHoverOnCell(day?.date)"
          (click)="onDayClick($event, day)"
          cdkDropList
          id="day-{{ day?.date }}"
          [cdkDropListConnectedTo]="cdkDragList"
          [cdkDropListData]="daysObject2[day?.date]?.progreses"
          (cdkDropListDropped)="drop($event, scheduleProjectMenu)">
          <div class="flex-container w-100">
            <ng-container *ngIf="week[i]?.dayName">
              <span class="text-bold text-ellipsis day-name">
                {{ week[i].dayName | translate | uppercase | slice: 0 : (breakpointState ? 3 : day?.day.length) }}
              </span>
            </ng-container>

            <div class="day-number__container w-100" [ngClass]="{ 'not-current-month': day?.isNotCurrentMonth }">
              <span class="day-number" [ngClass]="{ today: day?.isToday }">
                {{ day?.day }}
              </span>

              <ng-container *ngIf="daysObject2[day?.date]?.progresses.length">
                <day-progresses
                  [daysObject]="daysObject2"
                  [progresses]="daysObject2[day?.date]?.progresses"
                  [dayCellWidth]="dayCellWidth"
                  [maxProgressesLength]="week[0]?.maxProgressesLength || maxProgressesLength"
                  [day]="day"
                  [week]="week"
                  [hideActionBtns]="hideActionBtns"
                  (maxProgressesLengthChanged)="maxProgressesLengthChanged($event, week, day)"
                  (onProjectDeleted)="onDeleteAction($event)"
                  (onProjectEdited)="onEditAction($event)"
                  (emitExpandEvent)="calculateDayCellWidth()"
                  (hover)="onProgressHover($event)"
                  (click)="onProgressClick($event)"
                  (triggerDayClick)="onDayClick($event, day)"></day-progresses>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<span
  style="visibility: hidden; position: fixed"
  [style.left]="dropPoint?.x"
  [style.top]="dropPoint?.y"
  #scheduleProjectMenu
  [matMenuTriggerFor]="menu">
</span>

<mat-menu #menu>
  <unscheduled-project-menu
    [dropDate]="dropDate"
    [dragData]="dragData"
    [dropPoint]="dropPoint"
    (closeMenuEmit)="closeMenu()"
    (saveProject)="onScheduleModalSave($event)"></unscheduled-project-menu>
</mat-menu>

<ng-template #confirmInput let-config="config">
  <div class="checkbox">
    <label (click)="toggleCheckbox($event, config, 'deleteProject')" class="checkbox__label">
      <input type="checkbox" [checked]="config?.checkboxes?.deleteProject?.state" />
      <span class="checkbox__check"></span>
      <span class="checkbox__label">{{ config?.checkboxes?.deleteProject?.label | translate }}</span>
    </label>
  </div>
</ng-template>
